// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* CPA */
.servicenavbar {
  position: relative;
  display: flex;
  justify-content: space-around;
  top: -50px;
  width: 100%;
}

/* Carousel */
.about-us-service-title {
  text-align: center;
}

/* Carousel */
.carousel-container {
  padding: 20px;
  display: flex;
  position: relative;
  margin: 0 auto;
  min-height: 140vh;
}

.carousel-card {
  position: absolute;
  opacity: 1;
  width: 20%;
  cursor: pointer;
  left: 0; /* 确保起始位置是相同的 */
}

.planh {
  height: 1000px !important;
}

.carousel-card.far-left {
  left: 15%;
  transform: scale(0.9) translateY(0%) translateX(-50%);
  filter: brightness(0.5);
  z-index: 5;
}

.carousel-card.left {
  left: 30%;
  transform: scale(1) translateY(0%) translateX(-50%);
  filter: brightness(0.6);
  z-index: 10;
}

.carousel-card.center {
  left: 50%;
  transform: scale(1.05) translateY(0%) translateX(-50%);
  z-index: 15;
}

.carousel-card.right {
  left: 70%;
  transform: scale(1) translateY(0%) translateX(-50%);
  filter: brightness(0.6);
  z-index: 10;
}

.carousel-card.far-right {
  left: 80%;
  transform: scale(0.9) translateY(0%) translateX(-50%);
  filter: brightness(0.5);
  z-index: 5;
}

.carousel-card:hover {
  border-color: #007bff;
  box-shadow: 0px 0px 10px rgba(0, 123, 255, 0.5);
}

.nextstep {
  position: sticky;
  bottom: 0;
  background: white;
  text-align: center;
  padding: 2rem;
  z-index: 20;
}

.card {
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}

.dimmed {
  opacity: 0.5;
  filter: grayscale(50%);
}

.selected {
  opacity: 1;
  filter: none;
  border: 3px solid #007bff;
}

.plan-cards-row {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}

/* 2張或1張時：整排置中，但不影響卡片內容文字 */
.plan-cards-row.is-center {
  justify-content: center; /* ✅ 置中的是「卡片群組」 */
}

/* 讓每個 col 變成 flex 容器，卡片可以撐滿高度 */
.plan-cards-row > [class*=col-] {
  display: flex;
  float: none; /* ✅ 避免 BS3 float 影響 flex 排版 */
}

/* 卡片撐滿欄位高度（不改你卡片內部結構） */
.plan-cards-row > [class*=col-] > .card {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/registration/styles/plan.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,QAAA;AACA;EACI,kBAAA;EACA,aAAA;EACA,6BAAA;EACA,UAAA;EACA,WAAA;AAEJ;;AACA,aAAA;AAaA;EACI,kBAAA;AAVJ;;AAaA,aAAA;AACA;EACI,aAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AAVJ;;AAaA;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,OAAA,EAAA,eAAA;AAVJ;;AAaA;EACI,yBAAA;AAVJ;;AAaA;EACI,SAAA;EACA,qDAAA;EACA,uBAAA;EACA,UAAA;AAVJ;;AAaA;EACI,SAAA;EACA,mDAAA;EACA,uBAAA;EACA,WAAA;AAVJ;;AAaA;EACI,SAAA;EACA,sDAAA;EACA,WAAA;AAVJ;;AAaA;EACI,SAAA;EACA,mDAAA;EACA,uBAAA;EACA,WAAA;AAVJ;;AAaA;EACI,SAAA;EACA,qDAAA;EACA,uBAAA;EACA,UAAA;AAVJ;;AAaA;EACI,qBAAA;EACA,+CAAA;AAVJ;;AAaA;EACI,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;AAVJ;;AAaA;EACI,gCAAA;EACA,eAAA;AAVJ;;AAaA;EACI,YAAA;EACA,sBAAA;AAVJ;;AAaA;EACI,UAAA;EACA,YAAA;EACA,yBAAA;AAVJ;;AAaA;EACE,aAAA;EACA,eAAA;EACA,oBAAA;AAVF;;AAaA,2BAAA;AACA;EACE,uBAAA,EAAA,iBAAA;AAVF;;AAaA,gCAAA;AACA;EACE,aAAA;EACA,WAAA,EAAA,8BAAA;AAVF;;AAaA,wBAAA;AACA;EACE,WAAA;AAVF","sourcesContent":["/* CPA */\n.servicenavbar {\n    position: relative;\n    display: flex;\n    justify-content: space-around;\n    top: -50px;\n    width: 100%;\n}\n\n/* Carousel */\n// @media (max-width:1200px) {\n//     .wplan {\n//         display: none;\n//     }\n// }\n\n// @media (min-width:1200px) {\n//     .mplan {\n//         display: none;\n//     }\n// }\n\n.about-us-service-title {\n    text-align: center;\n}\n\n/* Carousel */\n.carousel-container {\n    padding: 20px;\n    display: flex;\n    position: relative;\n    margin: 0 auto;\n    min-height: 140vh;\n}\n\n.carousel-card {\n    position: absolute;\n    opacity: 1;\n    width: 20%;\n    cursor: pointer;\n    left: 0; /* 确保起始位置是相同的 */\n}\n\n.planh {\n    height: 1000px !important;\n}\n\n.carousel-card.far-left {\n    left: 15%;\n    transform: scale(0.9) translateY(0%) translateX(-50%);\n    filter: brightness(0.5);\n    z-index: 5;\n}\n\n.carousel-card.left {\n    left: 30%;\n    transform: scale(1) translateY(0%) translateX(-50%);\n    filter: brightness(0.6);\n    z-index: 10;\n}\n\n.carousel-card.center {\n    left: 50%;\n    transform: scale(1.05) translateY(0%) translateX(-50%);\n    z-index: 15;\n}\n\n.carousel-card.right {\n    left: 70%;\n    transform: scale(1) translateY(0%) translateX(-50%);\n    filter: brightness(0.6);\n    z-index: 10;\n}\n\n.carousel-card.far-right {\n    left: 80%;\n    transform: scale(0.9) translateY(0%) translateX(-50%);\n    filter: brightness(0.5);\n    z-index: 5;\n}\n\n.carousel-card:hover {\n    border-color: #007bff;\n    box-shadow: 0px 0px 10px rgba(0, 123, 255, 0.5);\n}\n\n.nextstep {\n    position: sticky;\n    bottom: 0;\n    background: white;\n    text-align: center;\n    padding: 2rem;\n    z-index: 20;\n}\n\n.card {\n    transition: all 0.3s ease-in-out;\n    cursor: pointer;\n}\n\n.dimmed {\n    opacity: 0.5;\n    filter: grayscale(50%);\n}\n\n.selected {\n    opacity: 1;\n    filter: none;\n    border: 3px solid #007bff;\n}\n\n.plan-cards-row{\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n}\n\n/* 2張或1張時：整排置中，但不影響卡片內容文字 */\n.plan-cards-row.is-center{\n  justify-content: center;  /* ✅ 置中的是「卡片群組」 */\n}\n\n/* 讓每個 col 變成 flex 容器，卡片可以撐滿高度 */\n.plan-cards-row > [class*=\"col-\"]{\n  display: flex;\n  float: none;              /* ✅ 避免 BS3 float 影響 flex 排版 */\n}\n\n/* 卡片撐滿欄位高度（不改你卡片內部結構） */\n.plan-cards-row > [class*=\"col-\"] > .card{\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
